import type { ReactNode } from 'react';

import { PostHogProvider as PostHogProviderCommon } from '@liscio/common';

import { config } from 'config';
import { useAuth } from 'fetch-utils/users/use-auth';
import { useHomeData } from 'fetch-utils/users/user-hooks';

/**
 * Firm app wrapper for PostHog (LISD-2217). Uses common provider with firm config and user_type from home data.
 */
export const PostHogProvider = ({ children }: { children?: ReactNode }) => {
  const { isLoggedIn } = useAuth();
  const { data: homeData } = useHomeData();

  const homeDataForPostHog = homeData?.data
    ? {
        current_cpa_user_uuid: homeData.data.current_cpa_user_uuid,
        cpa_uuid: homeData.data.cpa_uuid,
        userpilot_data: homeData.data.userpilot_data,
      }
    : undefined;

  const userRole = homeData?.data?.userpilot_data?.user_role;
  const userType = userRole === 'client' ? 'client' : 'firm';

  return (
    <PostHogProviderCommon
      projectToken={config.posthog.projectToken}
      host={config.posthog.host}
      isLoggedIn={isLoggedIn}
      homeData={homeDataForPostHog}
      userType={userType}
      appVersion={config.version}
      platform={config.platform}
      eventSampleRate={config.posthog.eventSampleRate}
    >
      {children}
    </PostHogProviderCommon>
  );
};
